const breakpoints = {
  values: {
    xs: 0,
    sm: 720,
    md: 960,
    lg: 1140,
    xl: 1400,
  },
};

export default breakpoints;
